import { render, staticRenderFns } from "./SlotButtons.vue?vue&type=template&id=0b40c0c2&scoped=true&"
import script from "./SlotButtons.vue?vue&type=script&lang=ts&setup=true&"
export * from "./SlotButtons.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./SlotButtons.vue?vue&type=style&index=0&id=0b40c0c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b40c0c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b40c0c2')) {
      api.createRecord('0b40c0c2', component.options)
    } else {
      api.reload('0b40c0c2', component.options)
    }
    module.hot.accept("./SlotButtons.vue?vue&type=template&id=0b40c0c2&scoped=true&", function () {
      api.rerender('0b40c0c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuScheduleCalendar/SlotButtons.vue"
export default component.exports